import { render, staticRenderFns } from "./FlipCard.vue?vue&type=template&id=513ecaa0"
import script from "./FlipCard.vue?vue&type=script&lang=js"
export * from "./FlipCard.vue?vue&type=script&lang=js"
import style0 from "./FlipCard.vue?vue&type=style&index=0&id=513ecaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports